export default __webpack_public_path__ + "media/images/images_v2/footer-36bc23056996a7dc1bd413f6497da57a.png";